import { render, staticRenderFns } from "./TemplateList.vue?vue&type=template&id=04fba2b0&scoped=true"
import script from "./TemplateList.vue?vue&type=script&lang=js"
export * from "./TemplateList.vue?vue&type=script&lang=js"
import style0 from "./TemplateList.vue?vue&type=style&index=0&id=04fba2b0&prod&scoped=true&lang=css"
import style1 from "./TemplateList.vue?vue&type=style&index=1&id=04fba2b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fba2b0",
  null
  
)

export default component.exports